export default {
  update (state, text) {
    state.text = text
  },
  toggleFilter (state) {
    state.filter = !state.filter
  }
}
